import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import jwt from 'jsonwebtoken'

import UsuarioService from '../../app/service/UsuarioService'
import LocalStorageService from '../../app/service/localStorageService'
import Progresso from '../../componentes/Progresso'
import { AuthContext  } from '../../main/ProvedorAutenticacao'

import '../css/util.css'
import './login.css'

import Logo from './img/ilaw-logo.png'
import capa from './img/capaLogin.png'

class Login2 extends React.Component {

  state = {
    email: '',
    senha: '',
    detail: '',
    classeDiv: 'hide',
    openSpinner: false,
		showModalRecuperacao: false
  }

  constructor(props) {
    super(props);
    this.service = new UsuarioService();
  }

  entrar = async () => {
    this.setState({openSpinner: true});
    await this.service.autenticar({
      email: this.state.email,
      senha: this.state.senha
    }).then(response => {
      this.context.iniciarSessao(response.data)
      this.setState({email: ''});
      this.setState({senha: ''});
      this.props.history.push('/home');
      this.refreshPage();
    }).catch(erro => {
      this.toast.show({severity:'error', summary: 'Autenticação', detail:'Usuário ou senha não conferem', life: 7000});
      console.log(erro.response.data)
    });

    this.setState({openSpinner: false});
  }

  refreshPage = () => {
    window.location.reload();
  }

	abrirModalRecuperacao = () => {
		console.log('Está chamando');
		this.setState({ showModalRecuperacao: true });
	}

	fecharModalRecuperacao = () => {
		this.setState({ showModalRecuperacao: false });
	}

  render() {
    return(
      <div className="body">
        <Toast ref={(el) => this.toast = el} position="top-center" />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="row">
          <div className="col-md-8" style={{backgroundColor: '#fff'}}>
            <div className="formGroup">
              <img className="background-container" src={capa}></img>
            </div>
          </div>
          <div className="col-md-4">
            <div className="formGroup">
              <div className="container-login100">
                <div className="wrap-login100kleiton">
                    <Progresso classeSecundaria={this.state.classeDiv}/>
                    <span className="login100-form-title"> 
                      <img style={{width: '200px', marginRight: '100px'}} src={Logo}></img>
                    </span>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">@</span>
                      </div>
                      <input type="email"
                            value={this.state.email}
                            autoComplete="nope"
                            onChange={e => this.setState({email: e.target.value})}
                            className="form-control" placeholder="E-mail"/>
                    </div>

                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text"><i className="fas fa-unlock-alt"></i></span>
                      </div>
                      <input type="password" 
                            autoComplete="nope"
                            value={this.state.senha}
                            onChange={e => this.setState({senha: e.target.value})}
                            className="form-control" placeholder="Senha"/>
                    </div>
                    <br/>
                    <div className="container-login100-form-btn">
                      <button className="login100-form-btn" onClick={ this.entrar }>
                        ENTRAR
                      </button>
                    </div>

                    <div className="text-center p-t-40">
                      <a className="txt1" onClick={this.abrirModalRecuperacao} style={{cursor: 'pointer'}}>
												Esqueceu a Senha?
											</a>
                    </div>
                    <div className="text-center p-t-40">
                        iLaw Gestão Jurídica 2022 - copyright © Goten1
                    </div>
										<Modal
											open={this.state.showModalRecuperacao}
											onClose={this.fecharModalRecuperacao}
										>
											<Box className="modal-recuperacao">
												
												<h2 className="modal-titulo">Recuperação de Senha</h2>

												<p className="modal-texto">
													Se o e-mail informado estiver cadastrado em nossa base, você receberá um link para redefinição de senha.
												</p>

												<Button 
													variant="contained" 
													onClick={this.fecharModalRecuperacao}
													className="modal-botao"
												>
													Fechar
												</Button>

											</Box>
										</Modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
Login2.contextType = AuthContext
export default withRouter (Login2)